"use client";

import { Skeleton, SkeletonText } from "@/components/ui/skeleton";

export default function RootLoading() {
  return (
    <main className="flex min-h-screen items-center justify-center p-8">
      <div className="w-full max-w-2xl space-y-4 animate-fade-in">
        <Skeleton variant="rectangular" className="aspect-[16/9] rounded-5" />
        <SkeletonText lines={3} />
      </div>
    </main>
  );
}
